import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // 1. Initialize state from localStorage or system preference
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('capstonne_theme');
    
    // Only return true if the user EXPLICITLY saved 'dark' previously
    // If savedTheme is null (new user), this returns false (Light Mode)
    return savedTheme === 'dark';
  });

  // 2. Update the HTML class and localStorage whenever state changes
  useEffect(() => {
    const root = window.document.documentElement;
    if (isDarkMode) {
      root.classList.add('dark');
      localStorage.setItem('capstonne_theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('capstonne_theme', 'light');
    }
  }, [isDarkMode]);

  const toggleTheme = () => setIsDarkMode(!isDarkMode);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);